export const components = {
  emptyState: {
    primaryTitle: 'Oh snap!',
    primaryText: 'No content here yet…',
    secondaryTitle: 'Nothing to display',
    secondaryText: 'Sad to say but there are no items to display based on applied filters…'
  },
  filters: {
    all: 'All',
    search: 'Search',
    priceRange: 'Price range {currency}',
    minValue: 'The minimum value is {val}!',
    maxValue: 'The maximum value is {val}!',
    reset: 'Reset',
    apply: 'Apply'
  },
  comments: {
    reply: 'Reply',
    loadMore: 'Load More',
    edited: 'Edited',
    noComments: 'There are no comments yet',
    leaveFirstComment: 'You can leave the first one'
  },
  curtain: {
    close: 'Close'
  },
  offline: {
    lostConnection: 'You are offline. Some features may be unavailable.',
    connectionRestored: 'Back online'
  },
  photoPreview: {
    close: 'Close'
  },
  photoCropper: {
    back: 'Back',
    save: 'Save'
  },
  rightSidebar: {
    in: 'in'
  },
  pushPrompt: {
    title: '“{appName}” would like to send you notifications',
    description: 'Notifications may include alerts, sounds, and icon badges. These can be configured in Settings.',
    later: 'Ask me later',
    neverLater: 'Never ask again',
    allow: 'Allow'
  },
  inAppPush: {
    attachment: 'Attachment'
  },
  installPrompt: {
    android: {
      install: 'Install',
      description: 'For a seamless experience you don’t need to use a browser. Just install it as an app.',
      press: 'Press',
      andSelect: 'and select',
      orSimply: 'or simply',
      description2: 'click Install button below',
      notNow: 'Not now'
    },
    ios: {
      justTap: 'Tap the',
      buttonInBrowser: '“More” button in your browser and select “Share”',
      addToHomeScreen: 'Scroll down and tap “Add to Home Screen”, then click “Add”',
      appWillBeInstalled: 'The app will be added to your Home Screen'
    },
    installApp: 'Install app',
    useWeb: 'Use Web Version'
  },
  footer: {
    more: 'Menu'
  },
  menu: {
    installApp: 'Install App',
    menu: 'Menu',
    close: 'Close'
  },
  404: {
    whoops: 'Whoops!',
    description:
      'Looks like the page doesn’t exist or maybe you don’t have access to it. Please contact an app owner for more details.',
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'See all'
  },
  camera: {
    NotAllowedError: 'To scan QR codes, please enable camera access in your device settings.',
    NotFoundError: 'No camera found. Please check if your device has a working camera.',
    NotSupportedError: 'Camera access requires a secure connection over HTTPS.',
    NotReadableError: 'Unable to access the camera. It might already be in use by another app.',
    OverconstrainedError: 'Requested camera not available. Please check your device camera options.',
    StreamApiNotSupportedError: "Your browser doesn't support the required camera features."
  },
  networkingCurtain: {
    'newOneOnOne': 'New 1:1',
    'details': 'Details',
    'coverMessage': 'Cover message',
    'location': 'Location',
    'duration': 'Duration',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Time slot',
    'sendInvitation': 'Send invitation',
    'success': 'Success',
    'invitationSent':
      'You have successfully sent the invitation to a 1:1 meet. Do you wish to stay on this page, or do you want to navigate to all of your scheduled 1:1?',
    'seeAll': 'See all 1:1 Meets',
    'stayHere': 'Stay Here'
  },
  networking: {
    level: {
      1: 'Not ready to network yet. No significant activity or engagement.',
      2: 'Rarely active or missing key profile details, making it hard for others to connect.',
      3: 'Profile completed with Photo and online, fully prepared to start networking.',
      4: 'Building momentum - initiated at least one connection in the past 6 hours.',
      5: 'A networking master - actively responding to requests and engaging with others in the last 6 hours.'
    }
  },
  time: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'in',
    Today: 'Today',
    today: 'today',
    Tomorrow: 'Tomorrow',
    tomorrow: 'tomorrow',
    Yesterday: 'Yesterday',
    yesterday: 'yesterday',
    startingNow: 'starting now'
  },
  daysMonths: {
    months: "['January','February','March','April','May','June','July','August','September','October','November','December']",
    monthsShort: "['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']",
    weekdays: "['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']",
    weekdaysShort: "['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']",
    weekdaysMin: "['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Achieve Legend level at least once by actively networking and making meaningful connections.',
    push_description: 'Enable push notifications to stay responsive and never miss an opportunity.',
    leader_description: 'Make it into the top 10% on the leaderboard at least once.',
    meetmaster_description: 'Initiate or respond to at least one 1:1 meeting request within the app.',
    connector_description: 'Set up at least three connections through the app during components.'
  }
}
